module.exports = __webpack_public_path__ + "img/1.efe4a9b2.jpg";